import { apiClient } from '../../lib/apiClient';
import type { FontRead } from '../../types/api';

/**
 * The font catalogue — the faces a community text box can be set in, in the
 * server's order. Global like `/slide-themes`: the fonts are vendored in the
 * render image, and only the ones that passed its render checks are listed,
 * so the gallery never offers a face the renderer cannot draw.
 */
export function listFonts(signal?: AbortSignal): Promise<FontRead[]> {
  return apiClient.get<FontRead[]>('/api/v1/fonts', { signal });
}
